export const AREA_ACTIONS = {
    AREA_SEARCH: 'AREA_SEARCH',
    AREA_SEARCH_SUCCESS: 'AREA_SEARCH_SUCCESS',
    AREA_SEARCH_ERROR: 'AREA_SEARCH_ERROR',

    AREA_UPSERT: 'AREA_UPSERT',
    AREA_UPSERT_SUCCESS: 'AREA_UPSERT_SUCCESS',
    AREA_UPSERT_ERROR: 'AREA_UPSERT_ERROR',

    AREA_EDIT: 'AREA_EDIT',

    AREA_RESET: 'AREA_RESET',
};

export const areaResetAction = () => ({
    type: AREA_ACTIONS.AREA_RESET,
});

export const areaSearchAction = (payload) => ({
    type: AREA_ACTIONS.AREA_SEARCH,
    ...payload,
});

export const areaEditAction = (payload) => ({
    type: AREA_ACTIONS.AREA_EDIT,
    ...payload,
});

export const areaUpsertAction = (payload) => ({
    type: AREA_ACTIONS.AREA_UPSERT,
    ...payload,
});

export default {
    AREA_ACTIONS,
    areaSearchAction,
    areaUpsertAction,
    areaEditAction,
};
